// eslint-disable-next-line strict
export default null;



// WEBPACK FOOTER //
// ./~/axios/lib/helpers/null.js